<template>
  <div>
    <v-container>

      <v-card style="background-color: white;">
        <div style="display: flex; padding: 15px; margin-bottom: 10px;">
          <v-text-field hide-details type="date" v-model="dateLogs" outlined dense
            style=" max-width: 200px; margin-left: 20px;">
          </v-text-field>
          <v-select :items="logFiles" v-model="logFileChoosed" hide-details outlined dense label="מחלקה"
            :item-text="'hebrewName'" :item-value="'name'" style="max-width: 200px; margin-left: 20px;">
          </v-select>
          <v-select v-if="logFileChoosed && logFileChoosed === 'web-app'" :items="logWebTypes"
            v-model="logTypeWebChoosed" hide-details outlined dense label="סוג לוגים"
            style="max-width: 200px; margin-left: 20px;">
          </v-select>
          <v-select v-else-if="logFileChoosed && logFileChoosed === 'asterisk'" :items="logAsteriskTypes"
            v-model="logTypeAsteriskChoosed" hide-details outlined dense label="סוג לוגים" :item-text="'hebrewName'"
            :item-value="'name'" style="max-width: 200px; margin-left: 20px;">
          </v-select>
          <v-select v-else-if="logFileChoosed && logFileChoosed === 'dialer'" :items="logDialerTypes"
            v-model="logTypeDialerChoosed" hide-details outlined dense label="סוג לוגים" :item-text="'hebrewName'"
            :item-value="'name'" style="max-width: 200px; margin-left: 20px;" @change="filterLogs">
          </v-select>
          <v-select v-else-if="logFileChoosed && logFileChoosed === 'ai'" :items="logAiTypes"
            v-model="logTypeAiChoosed" hide-details outlined dense label="הצג" :item-text="'hebrewName'"
            :item-value="'name'" style="max-width: 220px; margin-left: 20px;" @change="filterLogs">
          </v-select>

          <v-btn color="#0d2c6d" dark class="mb-2" style="max-width: 20px; " @click="getLogs()">
            אישור
          </v-btn>

          <v-btn outlined small class="mb-2 ms-4" style="max-width: 20px; margin-right: 70px !important;"
            @click="refreshDetails()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" dark>
                  mdi-refresh
                </v-icon>
              </template>
              <span>רענן תוצאות</span>
            </v-tooltip>
          </v-btn>

          <v-text-field label="חיפוש" style="max-width: 300px; margin-right: 30px;" hide-details outlined dense
            v-model="search" @input="debouncedSearch" clearable>
          </v-text-field>

          <v-text-field label="חיפוש נוסף" style="max-width: 300px; margin-right: 10px;" hide-details outlined dense
            v-model="search2" @input="debouncedSearch" clearable>
          </v-text-field>

        </div>

        <v-row v-if="progressShow" class="my-5">
          <v-col class="d-flex justify-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </v-col>
        </v-row>

        <div
          style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-bottom: 10px;">
          <span style="margin-right: 10px;">
            מציג: {{ displayedLogs.length }} {{ unitLabel }}
            <span v-if="filteredLogs.length !== logs.length"> | סוננו: {{ filteredLogs.length.toLocaleString() }}</span>
            <span v-if="logs.length > 0"> | סה"כ: {{ logs.length.toLocaleString() }}</span>
            <span v-if="loadedLines > 0 && loadedLines !== logs.length && logFileChoosed !== 'ai'"> (טוען... {{ loadedLines.toLocaleString()
            }})</span>
          </span>
        </div>

        <div style="overflow-y: auto; height: 65vh;" class="systembody">
          <div v-if="logFileChoosed === 'web-app'">
            <div v-for="(log, index) in displayedLogs" :key="index"
              style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              {{ log.date }} {{ log.time }}
              <span :class="getClass(log.level)">
                [{{ log.level }}]
              </span>
              <p class="log-message" v-html="formatLogWebMessage(log.message)"></p>
            </div>
          </div>

          <div v-else-if="logFileChoosed === 'asterisk' && logTypeAsteriskChoosed !== 'costume'">
            <div v-for="(log, index) in displayedLogs" :key="index"
              style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              <p v-html="formatLogAsteriskMessage(log)"></p>
            </div>
          </div>

          <div v-else-if="logFileChoosed === 'asterisk' && logTypeAsteriskChoosed === 'costume'">
            <div v-for="(log, index) in displayedLogs" :key="index"
              style="padding: 10px; border-bottom: 1px solid #ccc; direction: ltr;">
              <p v-html="formatCostumeLogAsteriskMessage(log)"></p>
            </div>
          </div>

          <!-- שיחות יוצאות (dialer) -->
          <div v-else-if="logFileChoosed === 'dialer'">
            <div v-for="(log, index) in displayedLogs" :key="index" class="dialer-row"
              :class="'dialer-' + (log.status || '').toLowerCase()">
              <span class="dialer-stamp">{{ log.stamp }}</span>
              <span class="dialer-status">{{ log.status }}</span>
              <span class="dialer-session" :style="{ color: sessionColor(log.session) }" @click="setSearch(log.session)"
                title="לחץ לסינון לפי סשן זה">[{{ log.session }}]</span>

              <span v-if="log.status === 'EVENT'" class="dialer-event">{{ log.text }}</span>

              <template v-else>
                <span v-for="(f, fi) in log.fields" :key="fi" class="dialer-field">
                  <span v-if="f.label" class="dialer-label">{{ f.label }}:</span>
                  <span :class="f.label === 'err' ? 'dialer-err' : ''">{{ f.value }}</span>
                </span>
              </template>

              <span v-if="log.raw" class="dialer-raw">{{ log.raw }}</span>
            </div>
          </div>
          <!-- עוזר קולי (AI): כרטיס לכל שיחה, עם השאלות והתשובות -->
          <div v-else-if="logFileChoosed === 'ai'" class="ai-list">
            <div v-for="conv in aiDisplayed" :key="conv.uuid" class="ai-conv" :class="'ai-result-' + conv.resultTone">
              <div class="ai-conv-head">
                <span class="ai-time">{{ conv.time }}</span>
                <span v-if="conv.line" class="ai-line" title="לחץ לסינון לפי הקו" @click="setSearch(conv.line)">{{ conv.line }}</span>
                <span v-else class="ai-muted">קו לא ידוע</span>
                <span v-if="conv.role" class="ai-role">{{ aiRoleLabel(conv.role) }}</span>
                <span v-if="conv.sec !== null" class="ai-meta">
                  <v-icon x-small color="#8a97b8">mdi-timer-outline</v-icon>{{ formatAiDuration(conv.sec) }}
                </span>
                <span class="ai-meta">
                  <v-icon x-small color="#8a97b8">mdi-forum-outline</v-icon>{{ aiTurnsLabel(conv.turns.length) }}
                </span>
                <span class="ai-spacer"></span>
                <span v-if="conv.reason && aiReasonLabel(conv.reason) !== aiResultLabel(conv.result)" class="ai-reason">{{ aiReasonLabel(conv.reason) }}</span>
                <span class="ai-result">{{ aiResultLabel(conv.result) }}</span>
              </div>
              <div v-if="conv.turns.length" class="ai-turns">
                <div v-for="(t, ti) in conv.turns" :key="ti" class="ai-turn">
                  <div v-if="t.q" class="ai-bubble ai-q">
                    <span class="ai-who">מתקשר</span>{{ t.q }}
                  </div>
                  <div v-if="t.a" class="ai-bubble ai-a" :class="{ 'ai-flag': t.unknown || t.unheard }">
                    <span class="ai-who">
                      העוזר
                      <span v-if="t.perceivedMs != null" class="ai-latency" :class="{ 'ai-slow': t.perceivedMs > aiSlowMs }"
                        title="זמן תגובה מסוף הדיבור של המתקשר">{{ (t.perceivedMs / 1000).toFixed(1) }} שנ׳</span>
                      <span v-if="t.unknown" class="ai-tag">לא ידע לענות</span>
                      <span v-else-if="t.unheard" class="ai-tag">לא שמע טוב</span>
                    </span>{{ t.a }}
                  </div>
                </div>
              </div>
              <div v-else class="ai-muted ai-empty">אין תמלול לשיחה הזו</div>
            </div>
          </div>
        </div>

        <!-- Pagination Controls at Bottom -->
        <div
          style="display: flex; justify-content: space-between; align-items: center; padding: 15px 10px; border-top: 1px solid #e0e0e0; background-color: #f5f5f5;">
          <v-select :items="pageSizeOptions" v-model="pageSize" hide-details outlined dense label="שורות לעמוד"
            style="max-width: 150px;" @change="changePageSize">
          </v-select>

          <div style="display: flex; align-items: center; gap: 10px;">
            <v-btn icon small @click="goToPage(1)" :disabled="currentPage === 1 || progressShow">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
            <v-btn icon small @click="previousPage" :disabled="currentPage === 1 || progressShow">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>

            <span style="min-width: 120px; text-align: center; font-weight: 500;">
              עמוד {{ currentPage }} מתוך {{ totalPages }}
            </span>

            <v-btn icon small @click="nextPage" :disabled="currentPage >= totalPages || progressShow">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon small @click="goToPage(totalPages)" :disabled="currentPage >= totalPages || progressShow">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
          </div>
        </div>

      </v-card>
    </v-container>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>

  </div>
</template>

<script>

import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'

// ===== לוגי העוזר הקולי (logs/ai/YYYY-MM-DD.jsonl) =====
// שורת JSON לכל שאלה (type: 'turn') ושורת סיכום לכל שיחה (type: 'session'), מקובצות לפי uuid
const AI_SLOW_MS = 3000;
const AI_UNKNOWN_RX = /לא יודע|אינני יודע|איני יודע|אין לי מידע/;
const AI_UNHEARD_RX = /לא שמעתי טוב|לחזור על השאלה/;
const AI_ROLE = { user: 'משתמש', manager: 'מנהל', owner: 'בעלים', support: 'תמיכה' };
const AI_RESULT = { ok: 'הצליחה', failed: 'נכשלה', busy: 'עומס', 'no-context': 'חסר הקשר' };
const AI_REASON = {
  'return-to-menu': 'חזר לתפריט', hangup: 'המתקשר ניתק', 'socket-closed': 'המתקשר ניתק',
  'socket-error': 'תקלת חיבור', 'audiosocket-error': 'תקלת AudioSocket', dtmf: 'הקיש לחזרה',
  'time-limit': 'הזמן נגמר', 'max-duration': 'הזמן נגמר', 'gemini-closed': 'Gemini סגר את החיבור',
  'gemini-go-away': 'Gemini ביקש לסיים', 'connect-failed': 'Gemini לא זמין', busy: 'עומס', 'no-context': 'חסר הקשר',
};
const AI_FILTERS = {
  failed: (c) => c.resultTone === 'fail',
  unknown: (c) => c.turns.some((t) => t.unknown),
  unheard: (c) => c.turns.some((t) => t.unheard),
  slow: (c) => c.turns.some((t) => t.perceivedMs > AI_SLOW_MS),
};

export default {

  components: {
    SnackBar
  },
  data: () => ({
    overlay: false,
    editPlanDialog: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    progressShow: false,
    logs: [],
    displayedLogs: [],
    loadedLines: 0,
    dateLogs: "",
    logFileChoosed: "asterisk",
    logTypeWebChoosed: "הכל",
    logTypeAsteriskChoosed: "costume",
    logFiles: [{ name: "asterisk", hebrewName: "אסטריסק" }, { name: "web-app", hebrewName: "אתר הניהול" }, { name: "dialer", hebrewName: "שיחות יוצאות" }, { name: "ai", hebrewName: "עוזר קולי (AI)" }],
    logWebTypes: ["הכל", "שגיאות", "מידע"],
    logAsteriskTypes: [{ name: "costume", hebrewName: "לוגים מותאם אישית" }, { name: "details", hebrewName: "מידע כללי" }, { name: "debug", hebrewName: "דיבאג" }, { name: "security", hebrewName: "אבטחה" }],
    logTypeDialerChoosed: "all",
    logDialerTypes: [{ name: "all", hebrewName: "הכל" }, { name: "OK", hebrewName: "נשלחו" }, { name: "FAIL", hebrewName: "כשלונות" }, { name: "EVENT", hebrewName: "אירועי קמפיין" }],
    logTypeAiChoosed: "all",
    logAiTypes: [{ name: "all", hebrewName: "כל השיחות" }, { name: "failed", hebrewName: "שיחות שנכשלו" }, { name: "unknown", hebrewName: "לא ידע לענות" }, { name: "unheard", hebrewName: "לא שמע טוב" }, { name: "slow", hebrewName: "תגובה איטית (מעל 3 שנ׳)" }],
    aiSlowMs: AI_SLOW_MS,
    search: "",
    search2: "",
    searchTimer: null,
    filteredLogs: [], // לוגים אחרי סינון
    colorCache: {},
    usedColors: [],
    maxColorCache: 10,

    // Pagination
    currentPage: 1,
    pageSize: 500,
    pageSizeOptions: [100, 500, 1000, 2000],
    totalLines: 0
  }),

  computed: {
    unitLabel() {
      return this.logFileChoosed === 'ai' ? 'שיחות' : 'שורות';
    },
    // רק כרטיסי שיחה (אם המחלקה הוחלפה לפני שנטענו לוגים חדשים, שורות גולמיות לא מוצגות כאן)
    aiDisplayed() {
      return this.displayedLogs.filter((c) => c && c.uuid && c.turns);
    },
    totalPages() {
      return Math.ceil(this.filteredLogs.length / this.pageSize) || 1;
    }
  },

  methods: {
    async getLogs() {
      try {
        this.logs = [];
        this.filteredLogs = [];
        this.displayedLogs = [];
        this.loadedLines = 0;
        this.totalLines = 0;
        this.currentPage = 1;
        this.search = ""; // נקה חיפוש
        this.search2 = ""; // נקה חיפוש נוסף
        this.progressShow = true;

        let token = localStorage.getItem("token");

        // logType רלוונטי רק ל-asterisk. ב-dialer וב-web-app הסינון מקומי.
        const logTypeParam = this.logFileChoosed === 'asterisk' ? this.logTypeAsteriskChoosed : '';

        // טען את כל הלוגים (ללא חיפוש - נעשה אותו מקומית)
        let api = process.env.VUE_APP_BASE_URL +
          `/logs/get_today_logs?date=${this.dateLogs}&fileType=${this.logFileChoosed}&logType=${logTypeParam}`;

        const response = await fetch(api, ApiServices.requestOptions("GET", "", token));

        if (response.status >= 400) {
          this.progressShow = false;
          this.showSnackBar("שגיאה בקבלת נתונים", "red");
          return;
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let chunksReceived = 0;

        while (true) {
          const { done, value } = await reader.read();

          if (done) break;

          buffer += decoder.decode(value, { stream: true });

          // Process line by line (NDJSON format)
          const lines = buffer.split('\n');

          // Keep the last incomplete line in buffer
          buffer = lines.pop() || '';

          // Process each complete line
          for (const line of lines) {
            if (!line.trim()) continue;

            try {
              const chunk = JSON.parse(line);

              if (chunk.batch && chunk.batch.length > 0) {
                this.logs.push(...chunk.batch);
                this.loadedLines = chunk.count;
                chunksReceived++;
              }

              // Last chunk received
              if (chunk.isLast) {
                this.totalLines = chunk.count;
              }
            } catch (e) {
              console.error('Failed to parse chunk:', e, line);
            }
          }
        }

        this.progressShow = false;

        // עוזר קולי: השורות מקובצות לשיחות, והדפדוף והחיפוש עובדים על שיחות
        if (this.logFileChoosed === "ai") {
          this.logs = this.buildAiConversations(this.logs);
        }

        // אחרי שטענו הכל, אתחל את filteredLogs
        this.filteredLogs = [...this.logs];

        // סינון סטטוס התחלתי לדיאלר, ואז עדכון התצוגה
        if ((this.logFileChoosed === "dialer" && this.logTypeDialerChoosed !== "all")
          || (this.logFileChoosed === "ai" && this.logTypeAiChoosed !== "all")) {
          this.filterLogs();
        } else {
          this.updateDisplayedLogs();
        }

      } catch (error) {
        this.progressShow = false;
        this.showSnackBar("Error get logs: " + error, "red");
      }
    },

    debouncedSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.filterLogs();
      }, 300);
    },

    filterLogs() {
      if (this.logFileChoosed === 'ai') {
        this.filterAiConversations();
        return;
      }
      const hasSearch1 = this.search && this.search.trim() !== '';
      const hasSearch2 = this.search2 && this.search2.trim() !== '';

      // סינון סטטוס לדיאלר - נעשה כאן ולא ב-applyFilters,
      // כדי שמספר העמודים והדפדוף יישארו נכונים
      const dialerStatus = (this.logFileChoosed === 'dialer' && this.logTypeDialerChoosed !== 'all')
        ? '\t' + this.logTypeDialerChoosed + '\t'
        : null;

      if (!hasSearch1 && !hasSearch2 && !dialerStatus) {
        this.filteredLogs = [...this.logs];
      } else {
        const searchLower1 = hasSearch1 ? this.search.toLowerCase() : '';
        const searchLower2 = hasSearch2 ? this.search2.toLowerCase() : '';

        this.filteredLogs = this.logs.filter(log => {
          if (typeof log !== 'string') return false;

          if (dialerStatus && !log.includes(dialerStatus)) return false;

          const logLower = log.toLowerCase();
          const match1 = !hasSearch1 || logLower.includes(searchLower1);
          const match2 = !hasSearch2 || logLower.includes(searchLower2);

          return match1 && match2;
        });
      }

      // חזור לעמוד 1 אחרי חיפוש
      this.currentPage = 1;
      this.updateDisplayedLogs();
    },

    /** לחיצה על מזהה סשן מסננת לפיו */
    setSearch(value) {
      this.search = String(value);
      this.filterLogs();
    },

    /** מקבץ את שורות ה-JSONL של העוזר לשיחות, החדשות קודם */
    buildAiConversations(lines) {
      const byId = new Map();
      for (const line of lines) {
        let r;
        try { r = JSON.parse(line); } catch (e) { continue; }
        if (!r || !r.uuid) continue;
        let c = byId.get(r.uuid);
        if (!c) {
          c = { uuid: r.uuid, line: '', role: '', firstT: r.t, lastT: r.t, turns: [], sec: null, reason: '', result: '' };
          byId.set(r.uuid, c);
        }
        if (r.line && !c.line) c.line = String(r.line);
        if (r.role && !c.role) c.role = r.role;
        if (r.t < c.firstT) c.firstT = r.t;
        if (r.t > c.lastT) c.lastT = r.t;
        if (r.type === 'session') {
          c.sec = r.sec;
          c.reason = r.reason || '';
          c.result = r.result || '';
        } else {
          const a = r.a || '';
          c.turns.push({ q: r.q || '', a, perceivedMs: r.perceivedMs, unknown: AI_UNKNOWN_RX.test(a), unheard: AI_UNHEARD_RX.test(a) });
        }
      }
      const list = [...byId.values()];
      for (const c of list) {
        // שורת הסיכום נכתבת בסוף השיחה, אז שעת ההתחלה = הסוף פחות המשך
        c.startMs = c.sec !== null ? Date.parse(c.lastT) - c.sec * 1000 : Date.parse(c.firstT);
        c.time = new Date(c.startMs).toLocaleTimeString('he-IL', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
        c.resultTone = !c.result ? 'open' : c.result === 'ok' ? 'ok' : 'fail';
        c.searchText = [c.line, AI_ROLE[c.role], c.reason, ...c.turns.map((t) => `${t.q} ${t.a}`)].join(' ').toLowerCase();
      }
      return list.sort((x, y) => y.startMs - x.startMs);
    },

    filterAiConversations() {
      const s1 = (this.search || '').trim().toLowerCase();
      const s2 = (this.search2 || '').trim().toLowerCase();
      const byType = AI_FILTERS[this.logTypeAiChoosed];
      this.filteredLogs = this.logs.filter((c) => c && c.uuid
        && (!byType || byType(c))
        && (!s1 || c.searchText.includes(s1))
        && (!s2 || c.searchText.includes(s2)));
      this.currentPage = 1;
      this.updateDisplayedLogs();
    },

    aiRoleLabel(role) {
      return AI_ROLE[role] || role;
    },
    aiResultLabel(result) {
      return result ? (AI_RESULT[result] || result) : 'בשיחה עכשיו';
    },
    // "time-limit/return-to-menu" -> "הזמן נגמר ← חזר לתפריט"
    aiReasonLabel(reason) {
      return String(reason).split('/').map((p) => AI_REASON[p] || p).join(' ← ');
    },
    aiTurnsLabel(n) {
      if (n === 0) return 'ללא שאלות';
      return n === 1 ? 'שאלה אחת' : `${n} שאלות`;
    },
    formatAiDuration(sec) {
      if (sec < 60) return `${sec} שנ׳`;
      return `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, '0')} דק׳`;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.updateDisplayedLogs();
      }
    },

    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updateDisplayedLogs();
      }
    },

    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.updateDisplayedLogs();
      }
    },

    changePageSize() {
      // כשמשנים את גודל העמוד, חזור לעמוד 1
      this.currentPage = 1;
      this.updateDisplayedLogs();
    },

    updateDisplayedLogs() {
      // חשב את הטווח לעמוד הנוכחי
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;

      // קח רק את השורות לעמוד הנוכחי מהלוגים המסוננים
      const pageData = this.filteredLogs.slice(startIndex, endIndex);

      if (this.logFileChoosed === "asterisk") {
        this.displayedLogs = [...pageData];
      } else if (this.logFileChoosed === "ai") {
        // עוזר קולי - כבר מקובץ לשיחות ב-buildAiConversations
        this.displayedLogs = pageData;
      } else if (this.logFileChoosed === "dialer") {
        // dialer - מופרד ב-TAB, לא ברווח
        this.displayedLogs = pageData.map(line => this.parseDialerLine(line));
      } else {
        // web-app - פרמט את הנתונים
        this.displayedLogs = pageData.map(line => {
          const parts = line.split(' ');
          return {
            date: parts[0],
            time: parts[1],
            level: parts[2],
            message: parts.slice(3).join(' ')
          };
        });
      }

      this.applyFilters();
    },

    /**
     * פירוק שורת דיאלר. הפורמט מ-dialerLogger:
     *   2026-09-03 14:56:43+03:00 \t OK \t [5809268] \t ivr: X \t phone: Y \t callerId: Z \t trunk: W
     *   2026-09-03 14:56:41+03:00 \t EVENT \t [5809268] \t [sendCalls] start ...
     */
    parseDialerLine(line) {
      const p = String(line).split('\t');

      // שורה שלא בפורמט המצופה - להציג כמו שהיא ולא לאבד אותה
      if (p.length < 3) {
        return { stamp: '', status: '', session: '', fields: [], raw: String(line) };
      }

      const stamp = p[0];
      const status = (p[1] || '').trim();
      const session = (p[2] || '').replace(/[[\]]/g, '').trim();
      const rest = p.slice(3);

      if (status === 'EVENT') {
        return { stamp, status, session, text: rest.join(' ') };
      }

      return {
        stamp,
        status,
        session,
        fields: rest.map(seg => {
          const i = seg.indexOf(': ');
          return i === -1
            ? { label: '', value: seg }
            : { label: seg.slice(0, i).trim(), value: seg.slice(i + 2) };
        }),
      };
    },

    /**
     * צבע קבוע לכל מזהה סשן. hash ולא random,
     * כדי שאותו סשן יקבל אותו צבע גם בין עמודים ובין רענונים.
     */
    sessionColor(id) {
      if (!id) return '#888';
      let h = 0;
      for (let i = 0; i < id.length; i++) {
        h = (h * 31 + id.charCodeAt(i)) | 0;
      }
      return `hsl(${Math.abs(h) % 360}, 70%, 35%)`;
    },

    formatLogsWebData() {
      // עכשיו רק מעדכן את התצוגה לעמוד הנוכחי
      this.updateDisplayedLogs();
    },

    formatLogsAsteriskData() {
      // עכשיו רק מעדכן את התצוגה לעמוד הנוכחי
      this.updateDisplayedLogs();
    },

    applyFilters() {
      let filtered = [...this.displayedLogs];

      // Filter by log type (web-app only)
      if (this.logFileChoosed === 'web-app') {
        if (this.logTypeWebChoosed === "שגיאות") {
          filtered = filtered.filter(
            (log) => log.level === "error:" || log.level === "exception:"
          );
        } else if (this.logTypeWebChoosed === "מידע") {
          filtered = filtered.filter(
            (log) => log.level !== "error:" && log.level !== "exception:"
          );
        }
      }

      this.displayedLogs = filtered;
    },

    formatLogWebMessage(message) {
      const keywords = /\b(SessionId|DataName|TableName|By|Message|Item|Error)\b/g;
      return message.replace(keywords, '<strong>$1</strong>');
    },

    formatLogAsteriskMessage(message) {
      const keywords = /\b(VERBOSE|Caller|Answer|NoOp|Goto|Set|AGI|Playing|GotoIf|DTMF|IVR)\b/g;
      const callPattern = /\[C-0000[^\]]*\]/g;

      message = message.replace(keywords, '<strong>$1</strong>');

      message = message.replace(callPattern, (match) => {
        if (!this.colorCache[match]) {
          if (this.usedColors.length >= this.maxColorCache) {
            this.usedColors.shift();
          }
          const newColor = this.getRandomColor();
          this.colorCache[match] = newColor;
          this.usedColors.push(newColor);
        }
        return `<span style="color:${this.colorCache[match]};">${match}</span>`;
      });

      return message;
    },

    formatCostumeLogAsteriskMessage(message) {
      const keywords = /\b(INFO|ERROR|EXCEPTION|CONTROL_STREAM_FILE|STREAM_FILE|GET_OPTION|PLAYBACK|READ_DIGITS|ENTER|DTMF|HANGUP|IVR|API|LINE_NUMBER|CALLER_ID|CONTEXT|Message)\b/g;
      const channelIdPattern = /CHANNEL_ID: [^,]+/;

      message = message.replace(keywords, (match) => {
        if (match === 'ERROR' || match === 'EXCEPTION') {
          return `<strong class="error-keyword">${match}</strong>`;
        } else {
          return `<strong class="keyword">${match}</strong>`;
        }
      });

      message = message.replace(channelIdPattern, (match) => {
        if (!this.colorCache[match]) {
          if (this.usedColors.length >= this.maxColorCache) {
            this.usedColors.shift();
          }
          const newColor = this.getRandomColor();
          this.colorCache[match] = newColor;
          this.usedColors.push(newColor);
        }
        const channelValue = match.replace("CHANNEL_ID: ", "");
        const channelTitle = "CHANNEL_ID: ";
        return `<span style="font-weight: bold;">${channelTitle}</span><span style="color:${this.colorCache[match]}; font-weight: bold;">${channelValue}</span>`;
      });

      return message;
    },

    getRandomColor() {
      const randomComponent = () => {
        return Math.floor(Math.random() * (192 - 32) + 32).toString(16).padStart(2, '0');
      };

      let color = `#${randomComponent()}${randomComponent()}${randomComponent()}`;
      while (this.usedColors.includes(color)) {
        color = `#${randomComponent()}${randomComponent()}${randomComponent()}`;
      }
      return color;
    },

    getClass(level) {
      return level === 'info:' ? 'level-info' : 'level-error';
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },

    setDateLogsToCurrentDate() {
      // לא toISOString - הוא מחזיר UTC, ואז בין חצות ל-03:00
      // שעון ישראל התאריך שנבחר הוא של אתמול
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      this.dateLogs = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },

    refreshDetails() {
      this.search = "";
      this.search2 = "";
      this.currentPage = 1;
      this.getLogs();
    }
  },

  created() {
    this.setDateLogsToCurrentDate();
  },

  beforeDestroy() {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
  }
}
</script>

<style scoped>
:deep(.keyword) {
  font-weight: bold;
  color: #0d47a1;
}

:deep(.error-keyword) {
  font-weight: bold;
  color: #d32f2f;
}

.level-info {
  color: rgb(24, 197, 24);
}

.level-error {
  color: red;
}

/* ===== שיחות יוצאות (dialer) ===== */
.dialer-row {
  direction: ltr;
  text-align: left;
  padding: 7px 12px;
  border-bottom: 1px solid #eee;
  font-family: "SF Mono", Menlo, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.6;
  white-space: nowrap;
  overflow-x: auto;
}

.dialer-row:hover {
  background-color: #fafafa;
}

.dialer-fail {
  background-color: #fff5f5;
}

.dialer-event {
  background-color: #f4f8ff;
  font-weight: 500;
}

.dialer-stamp {
  color: #777;
  margin-right: 10px;
}

.dialer-status {
  font-weight: 700;
  margin-right: 8px;
  display: inline-block;
  min-width: 46px;
}

.dialer-ok .dialer-status {
  color: #2e7d32;
}

.dialer-fail .dialer-status {
  color: #c62828;
}

.dialer-event .dialer-status {
  color: #1565c0;
}

.dialer-session {
  font-weight: 700;
  margin-right: 14px;
  cursor: pointer;
}

.dialer-session:hover {
  text-decoration: underline;
}

.dialer-field {
  margin-right: 16px;
}

.dialer-label {
  color: #9e9e9e;
  margin-right: 3px;
}

.dialer-err {
  color: #c62828;
  font-weight: 600;
}

.dialer-raw {
  color: #999;
}

/* ===== עוזר קולי (AI) ===== */
.ai-list { display: flex; flex-direction: column; gap: 12px; padding: 12px; direction: rtl; }
.ai-conv { background: #fff; border: 1px solid #e3e8f2; border-inline-start: 4px solid #c3cbe0; border-radius: 12px; padding: 12px 14px; }
.ai-result-ok { border-inline-start-color: #0d2c6d; }
.ai-result-fail { border-inline-start-color: #d64545; }
.ai-result-open { border-inline-start-color: #ffb91a; }
.ai-conv-head { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 14px; font-size: 13px; color: #5b6b8c; }
.ai-time { font-weight: 700; color: #183677; direction: ltr; }
.ai-line { font-weight: 700; color: #0d2c6d; direction: ltr; cursor: pointer; border-bottom: 1px dashed #9aa6c2; }
.ai-line:hover { border-bottom-color: #ffb91a; }
.ai-role { font-size: 12px; font-weight: 600; color: #0d2c6d; background: #eef2fa; border-radius: 20px; padding: 1px 10px; }
.ai-meta { display: inline-flex; align-items: center; gap: 3px; }
.ai-spacer { flex: 1; }
.ai-reason { font-size: 12px; }
.ai-result { font-size: 12px; font-weight: 700; border-radius: 20px; padding: 2px 10px; background: #eef2fa; color: #0d2c6d; }
.ai-result-fail .ai-result { background: #fdecec; color: #b42323; }
.ai-result-open .ai-result { background: #fff4d6; color: #8a6100; }
.ai-turns { display: flex; flex-direction: column; gap: 6px; margin-top: 10px; }
.ai-turn { display: flex; flex-direction: column; gap: 4px; }
.ai-bubble { max-width: 78%; padding: 8px 12px; border-radius: 12px; font-size: 14px; line-height: 1.55; white-space: pre-wrap; }
.ai-q { align-self: flex-start; background: #f2f4f8; color: #34405c; border-start-start-radius: 4px; }
.ai-a { align-self: flex-end; background: #eaf0fb; color: #183677; border-start-end-radius: 4px; }
.ai-flag { background: #fff4d6; box-shadow: inset 0 0 0 1px rgba(255, 185, 26, 0.6); }
.ai-who { display: block; font-size: 11px; font-weight: 700; color: #8a97b8; margin-bottom: 2px; }
.ai-latency { font-weight: 600; margin-inline-start: 6px; }
.ai-slow { color: #b42323; }
.ai-tag { margin-inline-start: 6px; color: #8a6100; }
.ai-muted { color: #9aa6c2; font-size: 13px; }
.ai-empty { margin-top: 8px; }
</style>